import gql from "graphql-tag";

export const STOP_ACTIVITY = gql`
  subscription stopActivity {
    stopActivity {
      _id
      title
      description
      tags
      key
      content
      timebox
      time {
        total_time
        start
        end
        paused {
          time
          continue
          total
        }
        created_at
      }
      project {
        title
      }
      created_by {
        _id
        email
        full_name
        avatar
      }
      created_at
    }
  }
`;
